// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6bd75a7","239":"12266510","455":"749ca20d"}[chunkId] + ".chunk.js";
};